import type { HTMLAttributes, ReactNode } from "react";

export interface CardProps extends HTMLAttributes<HTMLElement> {
  /** Variante visuelle :
   *  - `light` (défaut) : fond crème `#fffdf6` + bordure fine — usage standard
   *  - `dark` : gradient marron foncé — pour les hero ou blocs d'attention forte */
  variant?: "light" | "dark";
  /** Tag HTML rendu (article par défaut, mais on peut vouloir section/aside selon contexte). */
  as?: "article" | "section" | "aside" | "div";
  children?: ReactNode;
}

/**
 * Carte conteneur du design system champ-erp.
 * S'appuie sur les classes globales `.ui-card` et `.ui-card-dark` définies
 * dans le styles.css de l'app consommatrice.
 */
export function Card({
  variant = "light",
  as: Tag = "article",
  className = "",
  children,
  ...rest
}: CardProps) {
  const variantClass = variant === "dark" ? "ui-card-dark" : "ui-card";
  const composed = [variantClass, className].filter(Boolean).join(" ");
  return (
    <Tag className={composed} {...rest}>
      {children}
    </Tag>
  );
}
